module.exports = __webpack_public_path__ + "img/caymanasbetLogo.0018f8e3.png";